// @ts-nocheck
import { PUBLIC_BASE_URL } from '$env/static/public';
import { getAuthToken } from '#/lib/auth';

const base = PUBLIC_BASE_URL;
const authHeaders = () => {
	const token = getAuthToken();
	return token ? { 'auth-token': token } : {};
};

export function getAuthHeaders() {
	return authHeaders();
}

export async function getHome() {
	const res = await fetch(`${base}/home`, { headers: authHeaders() });
	if (res.status === 401) {
		const err = new Error('Unauthorized');
		/** @type {any} */ (err).status = 401;
		throw err;
	}
	if (!res.ok) throw new Error(`${res.status}`);
	return res.json();
}

export async function login(email, password) {
	const res = await fetch(`${base}/auth/login`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ email, password })
	});
	const json = await res.json();
	if (!res.ok) throw new Error(json.message || '로그인에 실패했습니다.');
	if (!json.token) throw new Error('토큰을 받지 못했습니다.');
	return json;
}

export async function register(email, password, name, type, settingIds = []) {
	const body = { email, password, name, type, settingIds: [...(settingIds ?? [])] };
	const res = await fetch(`${base}/auth/register`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', ...authHeaders() },
		body: JSON.stringify(body)
	});
	const json = await res.json();
	if (!res.ok) throw new Error(json.message || '회원가입에 실패했습니다.');
	return json;
}

export async function patchSelf(data) {
	const res = await fetch(`${base}/auth/self`, {
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json', ...authHeaders() },
		body: JSON.stringify(data)
	});
	const json = await res.json();
	if (!res.ok) throw new Error(json.message || '회원정보 수정에 실패했습니다.');
	return json;
}

export async function getUsers() {
	const res = await fetch(`${base}/auth/users`, { headers: authHeaders() });
	const json = await res.json();
	if (!res.ok) throw new Error(json.message || '유저 목록 조회에 실패했습니다.');
	return json;
}

export async function patchUser(id, data) {
	const res = await fetch(`${base}/auth/users/${id}`, {
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json', ...authHeaders() },
		body: JSON.stringify(data)
	});
	const json = await res.json();
	if (!res.ok) throw new Error(json.message || '유저 수정에 실패했습니다.');
	return json;
}

export async function deleteUser(id) {
	const res = await fetch(`${base}/auth/users/${id}`, {
		method: 'DELETE',
		headers: authHeaders()
	});
	const json = await res.json();
	if (!res.ok) throw new Error(json.message || '유저 삭제에 실패했습니다.');
	return json;
}
